"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Svg = styled_components_1["default"].svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: none;\n\n  ", "\n  ", "\n"], ["\n  flex: none;\n\n  ", "\n  ", "\n"])), styled_system_1.space, styled_system_1.color);
// @ts-ignore
Svg.isIcon = true;
Svg.displayName = 'Svg';
exports["default"] = Svg;
var templateObject_1;
//# sourceMappingURL=Svg.js.map